<div class="principal">
    <h1 class="textoPrincipal">Usuario <span class="textoSec">NÃO</span> autorizado !!!</h1>
    <br>
    <button class="botaoVoltar" (click)="goBack()">Voltar</button>
</div>